export const MemberRole = {
  User: 'user',
  Admin: 'admin',
};

export const MemberRoles = [
  { label: 'User', value: MemberRole.User },
  { label: 'Admin', value: MemberRole.Admin },
];
